import { useContext, useEffect } from 'react';

import { useAppSelector } from 'state/hooks';
import { selectRoadFilters } from 'state/workflowSlice';

import { MapContext } from '../MapContext';
import { getRoadClassLayerFilter, mapHasLayer } from '../utils/mapCommon';
import {
  kMetricsLayerId,
  kSegmentHoverId,
  kSegmentLayerId,
  kViewOnlySegmentLayerId,
} from '../utils/map_constants';

/** Layers that use a road-class filter */
const filterableLayers = [
  kSegmentLayerId,
  kViewOnlySegmentLayerId,
  kMetricsLayerId,
  kSegmentHoverId,
];

export function useRoadFilters() {
  const { refMap, mapReady, refStyleReady } = useContext(MapContext);
  const roadFilters = useAppSelector(selectRoadFilters);

  useEffect(() => {
    const map = refMap.current;
    if (!map || !mapReady || !refStyleReady.current) return;
    const filter = getRoadClassLayerFilter(roadFilters) ?? null;
    for (const layerId of filterableLayers)
      if (mapHasLayer(map, layerId)) map.setFilter(layerId, filter);
  }, [roadFilters, mapReady]);
}
